import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_ALL_COACHES} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {AllOrganizationCoachesContent} from './AllOrganizationCoachesContent';
import reportPayload from './reportPayload';

export const AllOrganizationCoachesReport = ({
  loadingData = {total: 0}, // Default value for loadingData
  tt = (key: string, defaultValue?: string) => defaultValue || '', // Default translation function
  showRecordPopover = () => {}, // No-op function
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'All Organization Coaches')}
      description={tt(
        'description',
        'All Coaches in your organization (all applicable generations).',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={AllOrganizationCoachesContent}
    />
  );
};

export default withHOC(
  withTranslation('report.AllOrganizationCoaches'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_ALL_COACHES,
    popoverContentProps: {
      renderTitle: () =>
        withTranslation.ts(
          'reportRecordTitle.allOrganization',
          'All Organization Coaches',
        ),
    },
  }),
)(AllOrganizationCoachesReport);
